import React, {
  useRef,
  useState,
  useLayoutEffect,
  useEffect,
  useContext,
} from "react";
import {
  View,
  Text,
  TouchableOpacity,
  Easing,
  Animated,
  Dimensions,
} from "react-native";
import CircularPie from "../../../../Components/CircularPie";
import getSheet from "./RotateStyle";
import { withRouter } from "react-router-dom";
import { ActivityContext } from "../../../Activities/index";
import LossPrePage from "./LossPrePage/index";
import LossSecondPage from "../Default/LossSecondPage";

import HeaderMandG from "../../../../Components/MandG/Header/index";
import { widthPercentageToDP as wp } from "../../../../Utils/responsive";
import {
  custom4,
  lossGainIntroTextMandGSA,
} from "../../../../Utils/static-strings";
import ContinueButton from "../../../../Components/ContinueButton";

const Loss = (props) => {
  const [gain, setGain] = useState(40);
  const [loss, setLoss] = useState(60);
  const [show, setShow] = useState(true);
  const [allValue, setAllValue] = useState(null);
  const [indexing, setIndexing] = useState(null);
  const [questionIndex, setQuestionIndex] = useState(0);
  const [currentSet, setCurrentSet] = useState(0);
  const [valueLength, setValueLength] = useState(4);
  const resultContext = useContext(ActivityContext);
  const animated1 = useRef(new Animated.Value(0)).current;
  const opacity = useRef(new Animated.Value(0)).current;
  const opacity2 = useRef(new Animated.Value(0)).current;
  const bottomViewY = useRef(new Animated.Value(0)).current;
  const tBar = useRef(new Animated.Value(0)).current;
  const yesButton = useRef(new Animated.Value(0)).current;
  const noButton = useRef(new Animated.Value(0)).current;
  const scaleButton = useRef(new Animated.Value(1)).current;
  const pinch = useRef(new Animated.Value(1)).current;

  const [display, setDisplay] = useState(false);
  const [disable, setDisable] = useState(true);
  const isMandGSA =
    sessionStorage.getItem("skinName")?.toLowerCase() ===
    custom4?.toLowerCase();
  const [showMandGSAIntro, setShowMandGSAIntro] = useState(isMandGSA);
  const findResearchValue = (array = []) => {
    const researchElement = array.find((element) =>
      element.startsWith("research.")
    );
    return researchElement ? researchElement.split(".")[1] : "Not Found";
  };
  const testingGroup = findResearchValue(props.moduleObject.tags || []);

  const pickFirstSetQuestions = (questions = []) => {
    if (!isMandGSA || questions.length === 0) {
      return questions;
    }
    const firstSetId = questions[0]?.qid?.split(".")[3]?.substring(0, 2);
    if (!firstSetId) {
      return questions;
    }
    return questions.filter((question) =>
      question.qid?.split(".")[3]?.startsWith(firstSetId)
    );
  };

  useLayoutEffect(() => {
    Animated.timing(tBar, {
      toValue: 1,
      duration: 1000,
      useNativeDriver: false,
      easing: Easing.linear,
    }).start(() => setDisplay(true));
  }, []);

  useEffect(() => {
    setShowMandGSAIntro(isMandGSA);
  }, [isMandGSA]);

  useEffect(() => {
    animate();

    Animated.sequence([
      Animated.timing(opacity, {
        toValue: 1,
        duration: 2500,
        useNativeDriver: false,
        easing: Easing.in(),
      }),
      Animated.timing(opacity2, {
        toValue: 1,
        duration: 900,
        useNativeDriver: false,
        easing: Easing.in,
      }),
      Animated.timing(bottomViewY, {
        toValue: 35,
        duration: 900,
        easing: Easing.linear,
        useNativeDriver: true,
      }),
    ]).start();
    if (props.moduleObject.questions) {
      const filteredQuestions = pickFirstSetQuestions(
        props.moduleObject.questions
      );

      const groupBySet = (questions) => {
        const sets = {};
        questions.forEach((question) => {
          const qidParts = question?.qid?.split(".") || [];
          if (qidParts[3]) {
            const setId = qidParts[3].substring(0, 2);
            if (!sets[setId]) {
              sets[setId] = [];
            }
            sets[setId].push(question);
          }
        });
        return Object.values(sets);
      };

      const groupedSets = groupBySet(filteredQuestions);

      setAllValue(groupedSets);

      const totalLength = groupedSets.map((elem) => ({
        length: elem.length,
      }));
      setIndexing(totalLength);
      setValueLength(groupedSets.length || 1);
    }

    setLoss(loss);
    setGain(gain);
  }, []);

  useLayoutEffect(() => {
    animate();
  }, [show]);

  useLayoutEffect(() => {
    if (valueLength !== null && currentSet >= valueLength) {
      resultContext.setModuleCompletedAtTime(props.moduleObject.moduleid);
      props.setfinishAnimate(props.moduleObject.moduleid);
      props.history.push("/");
      return;
    }
    if (currentSet > 0 && currentSet < valueLength) {
      setShow(true);
    }
  }, [
    currentSet,
    props.history,
    props.moduleObject.moduleid,
    props.setfinishAnimate,
    resultContext,
    valueLength,
  ]);

  const animate = () => {
    animated1.setValue(0);
    setDisable(true);
    Animated.timing(animated1, {
      toValue: 35,
      duration: 900,
      easing: Easing.linear,
      useNativeDriver: true,
    }).start(() => {
      setDisable(false);
    });
  };

  const yesAnimated = () => {
    yesButton.setValue(0);
    scaleButton.setValue(1);
    Animated.parallel([
      Animated.timing(scaleButton, {
        toValue: 1.6,
        duration: 200,
      }),
      Animated.timing(yesButton, {
        toValue: 1,
        duration: 700,
        easing: Easing.linear,
      }),
    ]).start(() => setDisable(false));
  };

  const noAnimated = () => {
    noButton.setValue(0);
    scaleButton.setValue(1);
    Animated.parallel([
      Animated.timing(scaleButton, {
        toValue: 1.6,
        duration: 200,
      }),
      Animated.timing(noButton, {
        toValue: 1,
        duration: 700,
        easing: Easing.linear,
      }),
    ]).start(() => setDisable(false));
  };

  const vanishButtons = () => {
    setTimeout(() => {
      Animated.sequence([
        Animated.timing(pinch, {
          toValue: 0,
          duration: 500,
          // delay: 1000
        }),
        Animated.timing(pinch, {
          toValue: 1,
          duration: 500,
          delay: 1600,
        }),
      ]).start();
    }, 600);
  };

  const yesInterpol = yesButton.interpolate({
    inputRange: [0, 0.6, 1],
    outputRange: ["0deg", "45deg", "0deg"],
  });

  const noInterpol = noButton.interpolate({
    inputRange: [0, 0.6, 1],
    outputRange: ["0deg", "-45deg", "0deg"],
  });

  const yesScalingInterpolate = yesButton.interpolate({
    inputRange: [0, 0.6, 1],
    outputRange: [1, 1.6, 1],
  });
  const noScalingInterpolate = noButton.interpolate({
    inputRange: [0, 0.6, 1],
    outputRange: [1, 1.6, 1],
  });

  // const animate2 = () => {
  //   animated1.setValue(35);
  //   Animated.timing(animated1, {
  //     toValue: 60,
  //     duration: 1000,
  //     easing: Easing.linear,
  //     useNativeDriver: true,
  //   }).start(() => animate());
  // };

  const spin = animated1.interpolate({
    inputRange: [5, 20],
    outputRange: ["360deg", "0deg"],
  });
  const transform = animated1.interpolate({
    inputRange: [0, 35],
    outputRange: [wp("120%"), wp("0%")],
  });

  const allOpacity = opacity.interpolate({
    inputRange: [0, 0.8, 1],
    outputRange: [0, 0, 1],
  });

  const opacityT2 = opacity2.interpolate({
    inputRange: [0, 0.8, 1],
    outputRange: [0, 0, 1],
  });

  const bottomViewTranslationY = bottomViewY.interpolate({
    inputRange: [0, 35],
    outputRange: [wp("120%"), wp("0%")],
  });

  const topBar = tBar.interpolate({
    inputRange: [0, 1],
    outputRange: ["0%", "100%"],
  });

  const styles = getSheet(show);

  const fun = () => {
    setShow(false);
  };

  // const prevQuestion = () => {
  //   if ((currentSet === 1 && questionIndex === 0) || (currentSet === 2 && questionIndex === 0) || (currentSet === 3 && questionIndex === 0)) {
  //     setCurrentSet(prev => prev - 1);
  //     setQuestionIndex(indexing[currentSet - 1].length - 1);
  //     props.setModuleIndex(indexing[currentSet - 1].length - 1);
  //   }
  //   else {
  //     setQuestionIndex(prev => prev - 1);
  //   }
  // };

  function closestNumber(n, m) {
    let q = parseInt(n / m);
    let n1 = m * q;
    let n2 = n * m > 0 ? m * (q + 1) : m * (q - 1);
    if (Math.abs(n - n1) < Math.abs(n - n2)) return n1;
    return n2;
  }

  const saveAnswer = (index) => {
    props.selectAnswerHandler(
      props.moduleObject.moduleid,
      allValue[currentSet][questionIndex].qid,
      allValue[currentSet][questionIndex].answers[index].respid
    );
  };

  const handleButtonClick = (answer, answerIndex) => {
    const answersForCurrent = allValue?.[currentSet];
    if (!answersForCurrent || !answersForCurrent[questionIndex]) {
      return;
    }

    const respId = (answer?.respid || "").toString().toLowerCase();
    const currentQid = answersForCurrent[questionIndex].qid || "";
    const qidParts = currentQid.split(".");
    const setId = qidParts[3] ? qidParts[3].substring(0, 2) : "01";
    const isEvenSet = parseInt(setId, 10) % 2 === 0;
    const skipRespid = isEvenSet ? "r01" : "r02";
    const shouldSkip = respId === skipRespid;
    const recordAnswer = (qIndex) => {
      props.selectAnswerHandler(
        props.moduleObject.moduleid,
        allValue[currentSet][qIndex].qid,
        allValue[currentSet][qIndex].answers[answerIndex].respid
      );
    };

    if (shouldSkip) {
      answerIndex === 0 ? yesAnimated() : noAnimated();
      if (indexing && indexing[currentSet]) {
        for (let i = questionIndex; i < indexing[currentSet].length; i++) {
          recordAnswer(i);
        }
      }
      setCurrentSet((prev) => prev + 1);
      setQuestionIndex(0);
      setDisable(true);
      return;
    }

    answerIndex === 0 ? yesAnimated() : noAnimated();
    recordAnswer(questionIndex);
    if (questionIndex < indexing[currentSet].length - 1) {
      setQuestionIndex((prev) => prev + 1);
    } else {
      setQuestionIndex(0);
      setCurrentSet((prev) => prev + 1);
      setDisable(true);
    }
  };

  const [screenDimensions, setScreenDimensions] = useState(
    Dimensions.get("window")
  );
  useEffect(() => {
    const onChange = ({ window }) => {
      setScreenDimensions(window);
    };

    Dimensions.addEventListener("change", onChange);

    return () => Dimensions.removeEventListener("change", onChange);
  }, []);

  const hasActiveSet =
    Array.isArray(allValue) &&
    allValue[currentSet] &&
    currentSet < valueLength &&
    allValue[currentSet][questionIndex];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "var(--game-background-color-la)",
        height: "100vh",
        width: "100vw",
        overflow: "hidden",
      }}
    >
      <HeaderMandG currentRoute={"Understanding"} />
      <div style={{ flex: 1, display: "flex", minHeight: 0 }}>
        {show ? (
          <>
            {display && (
              <>
                {isMandGSA ? (
                  showMandGSAIntro ? (
                    <View
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 24,
                        padding: 24,
                      }}
                    >
                      <h1
                        style={{
                          fontSize: 32,
                          letterSpacing: 1,
                          margin: 0,
                          color: "var(--text-color-default)",
                        }}
                      >
                        Loss & Gain
                      </h1>
                      {lossGainIntroTextMandGSA.split("\n").map((line) => (
                        <p
                          key={line}
                          style={{
                            maxWidth: 520,
                            textAlign: "center",
                            margin: 0,
                            fontFamily: "Infra",
                            fontSize: 18,
                            lineHeight: "28px",
                            color: "var(--text-color-default)",
                          }}
                        >
                          {line}
                        </p>
                      ))}
                      <ContinueButton onClick={() => setShowMandGSAIntro(false)} />
                    </View>
                  ) : (
                    <LossSecondPage
                      testingGroup={testingGroup}
                      showDescriptionPage={fun}
                    />
                  )
                ) : (
                  <LossPrePage
                    fun={fun}
                    setDisable={setDisable}
                    currentSet={currentSet}
                    moduleObject={props.moduleObject}
                  />
                )}
              </>
            )}
          </>
        ) : (
          <View
            style={{ flex: 1, justifyContent: "center", height: "100%", gap: 15 }}
          >
            <View>
              <Animated.View
                style={
                  (styles.headingContainer,
                  { opacity: allOpacity, marginTop: "5%" })
                }
              >
                <Text style={styles.headerMandG}>A spinner is spun.</Text>
                <Text style={styles.headerMandG}>If it lands on...</Text>
              </Animated.View>
            </View>
            <CircularPie
              activeColor="var(--module-color-la-active)"
              passiveColor="var(--module-color-la-passive)"
              baseColor="var(--text-color-light)"
              width={50}
              circularPieForMandG={true}
              done={
                hasActiveSet
                  ? allValue[currentSet][questionIndex].metadata.lossratio < 0.5
                    ? closestNumber(
                        (1 -
                          allValue[currentSet][questionIndex].metadata
                            .lossratio) *
                          100,
                        5
                      )
                    : closestNumber(
                        allValue[currentSet][questionIndex].metadata.lossratio *
                          100,
                        5
                      )
                  : 0
              }
              ratio={
                hasActiveSet
                  ? allValue[currentSet][questionIndex].metadata.lossratio
                  : 0
              }
              isBlueOverDark={
                hasActiveSet &&
                currentSet !== valueLength &&
                allValue[currentSet][questionIndex].metadata.lossratio !== 0.5
              }
              setDisable={setDisable}
              setTriangle={hasActiveSet && (currentSet === 2 || currentSet === 3)}
              gain={
                hasActiveSet
                  ? allValue[currentSet][questionIndex].metadata.winamount
                  : 0
              }
              loss={
                hasActiveSet
                  ? allValue[currentSet][questionIndex].metadata.lossamount
                  : 0
              }
              radius={
                screenDimensions.height < 700 || screenDimensions.width < 600
                  ? 100
                  : 120
              }
              bigRadius={120}
              smallRadius={100}
              duration={600}
              showPercentage={false}
              showAmount={true}
              hideBracket={true}
            />
            <Animated.View
              style={[styles.bottomView, { flexDirection: "column" }]}
            >
              <Text style={styles.headerMandG}>Would you play?</Text>
              <View style={styles.button5Container}>
                {hasActiveSet &&
                  allValue[currentSet][questionIndex].answers.map((answer, i) => {
                    return (
                      <TouchableOpacity
                        disabled={disable}
                        key={i}
                        onPress={() => {
                          handleButtonClick(answer, i);
                          setDisable(true);
                          vanishButtons();
                        }}
                        style={[
                          i === 0
                            ? { marginTop: 10, marginRight: "5vh" }
                            : { marginTop: 10 },
                        ]}
                      >
                        <Animated.View
                          style={[
                            styles.button5,
                            i === 0
                              ? {
                                  transform: [
                                    { scale: yesScalingInterpolate },
                                    { rotate: yesInterpol },
                                  ],
                                }
                              : {
                                  transform: [
                                    { scale: noScalingInterpolate },
                                    { rotate: noInterpol },
                                  ],
                                },
                          ]}
                        >
                          <Text style={styles.button5text}>{answer.text}</Text>
                        </Animated.View>
                      </TouchableOpacity>
                    );
                  })}
              </View>
            </Animated.View>
          </View>
        )}
      </div>
    </div>
  );
};

export default withRouter(Loss);
